// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ===================== */
/*        SCSS VARS       */
/* ===================== */
/* ===================== */
/*      CSS VARIABLES     */
/* ===================== */
:root {
  /* Text */
  --base-text-color: #1D1D1D;
  --darker-text-color: #202020;
  --brighter-text-color: #696969;
  /* UI */
  --base-ui-color: #E67817;
  --warning-ui-color: #F8A01E;
  --secondary-ui-color: #E8E4E4;
  /* Background */
  --base-bg-color: #F5F5F5;
  /* Grays */
  --color-gray: #B2B2B2;
  --color-gray-2: #9E9E9E;
  --color-gray-3: #D8D8D8;
  --color-dark-gray: #676767;
  /* Fonts */
  --main-font: Noto Sans;
  --secondary-font: Roboto;
  --third-font: Open Sans;
  --fourth-font: Dosis;
  /* Error */
  --error-color: #E00000;
  /* Border */
  --border-color: #D8D8D8;
}

.rowContainer {
  display: flex;
  flex-direction: row;
  column-gap: 24px;
  row-gap: 24px;
  flex-wrap: wrap;
  margin-bottom: 32px;
}

.card {
  display: flex;
  flex-direction: column;
  background-color: white;
  border-radius: 8px;
  padding: 24px;
}
.card .label {
  font: normal normal normal 14px/17px Dosis;
  font-size: 24px;
  font-weight: 400;
  padding-bottom: 28px;
}
.card .childrenContainer {
  display: flex;
  flex-direction: row;
  column-gap: 24px;
}
.card .childrenContainerColumn {
  display: flex;
  flex-direction: column;
  gap: 24px;
  justify-content: center;
  align-items: center;
  min-width: 240px;
}

.statButton {
  display: flex;
  flex-direction: column;
  row-gap: 12px;
  padding: 24px 12px 24px 12px;
  cursor: pointer;
}
.statButton .valueText {
  font: normal normal normal 14px/17px Dosis;
  font-size: 28px;
  font-weight: 500;
  color: #E67817;
}
.statButton .descriptionText {
  font: normal normal normal 14px/17px Dosis;
  font-size: 20px;
  font-weight: 400;
  color: #434343;
}
.statButton.--active {
  background-color: #E67817;
  border-radius: 8px;
  cursor: pointer;
  transition: background-color 200ms;
}
.statButton.--active .valueText {
  color: white;
  font-weight: 500;
  transition: color 200ms;
}
.statButton.--active .descriptionText {
  color: white;
  font-weight: 400;
  transition: color 200ms;
}

.stat {
  display: flex;
  flex-direction: column;
  row-gap: 12px;
}
.stat .valueText {
  font: normal normal normal 14px/17px Dosis;
  font-size: 28px;
  font-weight: 500;
  color: #E67817;
}
.stat .descriptionText {
  font: normal normal normal 14px/17px Dosis;
  font-size: 20px;
  font-weight: 400;
  color: #434343;
}

.statButton:hover {
  background-color: rgba(230, 120, 23, 0.8);
  border-radius: 8px;
  cursor: pointer;
  transition: background-color 200ms;
}
.statButton:hover .valueText {
  color: white;
  font-weight: 500;
  transition: color 200ms;
}
.statButton:hover .descriptionText {
  color: white;
  font-weight: 400;
  transition: color 200ms;
}

.rowHeaderText {
  display: block;
  font: normal normal normal 14px/17px Dosis;
  font-size: 24px;
  font-weight: 500;
  color: #434343;
  padding-bottom: 20px;
}

.tabButton {
  min-width: 16rem;
  text-align: center;
  display: inline-block;
  background-color: white;
  border: #B2B2B2 solid 1px;
  padding: 14px 24px 14px 24px;
  font: normal normal normal 14px/17px Dosis;
  font-size: 20px;
  font-weight: 200;
  color: #B2B2B2;
  border-radius: 8px;
  cursor: pointer;
}
.tabButton.--active {
  background-color: #E67817;
  color: white;
  border-color: #E67817;
}
.tabButton.--small {
  min-width: 8rem;
  font-size: 16px;
  padding: 8px 16px 8px 16px;
}

.tabButton:hover {
  border: #B2B2B2 solid 1px;
  background-color: rgba(230, 120, 23, 0.8);
  color: white;
  transition: background-color 200ms, color 200ms, border 200ms;
}

.tabContainer {
  display: flex;
  flex-direction: "row";
  column-gap: 16px;
}

.bigCard {
  display: flex;
  margin-top: 24px;
  flex-direction: column;
  row-gap: 24px;
  padding: 12px;
  background-color: white;
  border-radius: 8px;
}
.bigCard .header {
  color: #E67817;
  font: normal normal normal 14px/17px Dosis;
  font-size: 22px;
  font-weight: 500;
}
.bigCard .label {
  color: #434343;
  font: normal normal normal 14px/17px Dosis;
  font-size: 20px;
  font-weight: 500;
}

.itemsContainer {
  display: flex;
  flex-direction: column;
  row-gap: 12px;
}

.itemRow {
  display: flex;
  width: 40vw;
  flex-direction: "row";
  column-gap: 8px;
}

.item {
  flex: 1 1;
  background-color: #EDEDED;
  border-radius: 8px;
  padding: 12px 12px;
  text-align: center;
  color: #434343;
}
.item.left {
  min-width: 70%;
  text-align: start;
}

.iconRound {
  color: #E67817;
}`, "",{"version":3,"sources":["webpack://./src/styles/_variables.scss","webpack://./src/components/reports/reports.scss"],"names":[],"mappings":"AAAA,0BAAA;AACA,2BAAA;AACA,0BAAA;AA2BA,0BAAA;AACA,2BAAA;AACA,0BAAA;AAEA;EACE,SAAA;EACA,0BAAA;EACA,4BAAA;EACA,8BAAA;EAEA,OAAA;EACA,wBAAA;EACA,2BAAA;EACA,6BAAA;EAEA,eAAA;EACA,wBAAA;EAEA,UAAA;EACA,qBAAA;EACA,uBAAA;EACA,uBAAA;EACA,0BAAA;EAEA,UAAA;EACA,sBAAA;EACA,wBAAA;EACA,uBAAA;EACA,oBAAA;EAEA,UAAA;EACA,sBAAA;EAEA,WAAA;EACA,uBAAA;AChCF;;AA7BA;EACE,aAAA;EACA,mBAAA;EACA,gBAAA;EACA,aAAA;EACA,eAAA;EACA,mBAAA;AAgCF;;AA7BA;EACE,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,kBAAA;EACA,aAAA;AAgCF;AA9BE;EACE,0CAAA;EACA,eAAA;EACA,gBAAA;EACA,oBAAA;AAgCJ;AA7BE;EACE,aAAA;EACA,mBAAA;EACA,gBAAA;AA+BJ;AA5BE;EACE,aAAA;EACA,sBAAA;EACA,SAAA;EACA,uBAAA;EACA,mBAAA;EACA,gBAAA;AA8BJ;;AA1BA;EACE,aAAA;EACA,sBAAA;EACA,aAAA;EACA,4BAAA;EACA,eAAA;AA6BF;AA3BE;EACE,0CAAA;EACA,eAAA;EACA,gBAAA;EACA,cD5CY;ACyEhB;AA1BE;EACE,0CAAA;EACA,eAAA;EACA,gBAAA;EACA,cAAA;AA4BJ;AAzBE;EACE,yBDvDY;ECwDZ,kBAAA;EACA,eAAA;EACA,kCAAA;AA2BJ;AAzBI;EACE,YAAA;EACA,gBAAA;EACA,uBAAA;AA2BN;AAxBI;EACE,YAAA;EACA,gBAAA;EACA,uBAAA;AA0BN;;AArBA;EACE,aAAA;EACA,sBAAA;EACA,aAAA;AAwBF;AAtBE;EACE,0CAAA;EACA,eAAA;EACA,gBAAA;EACA,cDnFY;AC2GhB;AArBE;EACE,0CAAA;EACA,eAAA;EACA,gBAAA;EACA,cAAA;AAuBJ;;AAnBA;EACE,yCAAA;EACA,kBAAA;EACA,eAAA;EACA,kCAAA;AAsBF;AApBE;EACE,YAAA;EACA,gBAAA;EACA,uBAAA;AAsBJ;AAnBE;EACE,YAAA;EACA,gBAAA;EACA,uBAAA;AAqBJ;;AAjBA;EACE,cAAA;EACA,0CAAA;EACA,eAAA;EACA,gBAAA;EACA,cAAA;EACA,oBAAA;AAoBF;;AAjBA;EACE,gBAAA;EACA,kBAAA;EACA,qBAAA;EACA,uBAAA;EACA,yBAAA;EACA,4BAAA;EACA,0CAAA;EACA,eAAA;EACA,gBAAA;EACA,cAAA;EACA,kBAAA;EACA,eAAA;AAoBF;AAlBE;EACE,yBDzIY;EC0IZ,YAAA;EACA,qBD3IY;AC+JhB;AAjBE;EACE,eAAA;EACA,eAAA;EACA,0BAAA;AAmBJ;;AAfA;EACE,yBAAA;EACA,yCAAA;EACA,YAAA;EACA,6DAAA;AAkBF;;AAfA;EACE,aAAA;EACA,qBAAA;EACA,gBAAA;AAkBF;;AAfA;EACE,aAAA;EACA,gBAAA;EACA,sBAAA;EACA,aAAA;EACA,aAAA;EACA,uBAAA;EACA,kBAAA;AAkBF;AAhBE;EACE,cD5KY;EC6KZ,0CAAA;EACA,eAAA;EACA,gBAAA;AAkBJ;AAfE;EACE,cAAA;EACA,0CAAA;EACA,eAAA;EACA,gBAAA;AAiBJ;;AAZA;EACE,aAAA;EACA,sBAAA;EACA,aAAA;AAeF;;AAZA;EACE,aAAA;EACA,WAAA;EACA,qBAAA;EACA,eAAA;AAeF;;AAZA;EACE,SAAA;EACA,yBAAA;EACA,kBAAA;EACA,kBAAA;EACA,kBAAA;EACA,cAAA;AAeF;AAbE;EACE,cAAA;EACA,iBAAA;AAeJ;;AAXA;EACE,cDvNc;ACqOhB","sourcesContent":["/* ===================== */\n/*        SCSS VARS       */\n/* ===================== */\n\n$base-text-color: #1D1D1D;\n$darker-text-color: #202020;\n$brighter-text-color: #696969;\n\n$base-ui-color: #E67817;\n$warning-ui-color: #F8A01E;\n$secondary-ui-color: #E8E4E4;\n\n$base-bg-color: #F5F5F5;\n\n$color-gray: #B2B2B2;\n$color-gray-2: #9E9E9E;\n$color-gray-3: #D8D8D8;\n$color-dark-gray: #676767;\n\n$main-font: \"Noto Sans\";\n$secondary-font: \"Roboto\";\n$third-font: \"Open Sans\";\n$fourth-font: \"Dosis\";\n\n$error-color: #E00000;\n\n$border-color: #D8D8D8;\n\n\n/* ===================== */\n/*      CSS VARIABLES     */\n/* ===================== */\n\n:root {\n  /* Text */\n  --base-text-color: #{$base-text-color};\n  --darker-text-color: #{$darker-text-color};\n  --brighter-text-color: #{$brighter-text-color};\n\n  /* UI */\n  --base-ui-color: #{$base-ui-color};\n  --warning-ui-color: #{$warning-ui-color};\n  --secondary-ui-color: #{$secondary-ui-color};\n\n  /* Background */\n  --base-bg-color: #{$base-bg-color};\n\n  /* Grays */\n  --color-gray: #{$color-gray};\n  --color-gray-2: #{$color-gray-2};\n  --color-gray-3: #{$color-gray-3};\n  --color-dark-gray: #{$color-dark-gray};\n\n  /* Fonts */\n  --main-font: #{$main-font};\n  --secondary-font: #{$secondary-font};\n  --third-font: #{$third-font};\n  --fourth-font: #{$fourth-font};\n\n  /* Error */\n  --error-color: #{$error-color};\n\n  /* Border */\n  --border-color: #{$border-color};\n}","@import '../../styles/variables';\n\n.rowContainer {\n  display: flex;\n  flex-direction: row;\n  column-gap: 24px;\n  row-gap: 24px;\n  flex-wrap: wrap;\n  margin-bottom: 32px;\n}\n\n.card {\n  display: flex;\n  flex-direction: column;\n  background-color: white;\n  border-radius: 8px;\n  padding: 24px;\n\n  .label {\n    font: normal normal normal 14px/17px Dosis;\n    font-size: 24px;\n    font-weight: 400;\n    padding-bottom: 28px;\n  }\n\n  .childrenContainer {\n    display: flex;\n    flex-direction: row;\n    column-gap: 24px\n  }\n\n  .childrenContainerColumn {\n    display: flex;\n    flex-direction: column;\n    gap: 24px;\n    justify-content: center;\n    align-items: center;\n    min-width: 240px;\n  }\n}\n\n.statButton {\n  display: flex;\n  flex-direction: column;\n  row-gap: 12px;\n  padding: 24px 12px 24px 12px;\n  cursor: pointer;\n  \n  .valueText {\n    font: normal normal normal 14px/17px Dosis;\n    font-size: 28px;\n    font-weight: 500;\n    color: $base-ui-color;\n  }\n\n  .descriptionText {\n    font: normal normal normal 14px/17px Dosis;\n    font-size: 20px;\n    font-weight: 400;\n    color: #434343;\n  }\n\n  &.--active {\n    background-color: $base-ui-color;\n    border-radius: 8px;\n    cursor: pointer;\n    transition: background-color 200ms;\n\n    .valueText {\n      color: white;\n      font-weight: 500;\n      transition: color 200ms;\n    }\n\n    .descriptionText {\n      color: white;\n      font-weight: 400;\n      transition: color 200ms;\n    }\n  }\n}\n\n.stat {\n  display: flex;\n  flex-direction: column;\n  row-gap: 12px;\n\n  .valueText {\n    font: normal normal normal 14px/17px Dosis;\n    font-size: 28px;\n    font-weight: 500;\n    color: $base-ui-color;\n  }\n\n  .descriptionText {\n    font: normal normal normal 14px/17px Dosis;\n    font-size: 20px;\n    font-weight: 400;\n    color: #434343;\n  }\n}\n\n.statButton:hover {\n  background-color: rgba($base-ui-color, 0.8);\n  border-radius: 8px;\n  cursor: pointer;\n  transition: background-color 200ms;\n  \n  .valueText {\n    color: white;\n    font-weight: 500;\n    transition: color 200ms;\n  }\n  \n  .descriptionText {\n    color: white;\n    font-weight: 400;\n    transition: color 200ms;\n  }\n}\n\n.rowHeaderText {\n  display: block;\n  font: normal normal normal 14px/17px Dosis;\n  font-size: 24px;\n  font-weight: 500;\n  color: #434343;\n  padding-bottom: 20px;\n}\n\n.tabButton {\n  min-width: 16rem;\n  text-align: center;\n  display: inline-block;\n  background-color: white;\n  border: #B2B2B2 solid 1px;\n  padding: 14px 24px 14px 24px;\n  font: normal normal normal 14px/17px Dosis;\n  font-size: 20px;\n  font-weight: 200;\n  color: #B2B2B2;\n  border-radius:  8px;\n  cursor: pointer;\n  \n  &.--active {\n    background-color: $base-ui-color;\n    color: white;\n    border-color: $base-ui-color;\n  }\n  \n  &.--small {\n    min-width: 8rem;\n    font-size: 16px;\n    padding: 8px 16px 8px 16px;\n  }\n}\n\n.tabButton:hover {\n  border: #B2B2B2 solid 1px;\n  background-color: rgba($base-ui-color, 0.8);\n  color: white;\n  transition: background-color 200ms, color 200ms, border 200ms;\n}\n\n.tabContainer {\n  display: flex;\n  flex-direction: 'row';\n  column-gap: 16px;\n}\n\n.bigCard {\n  display: flex;\n  margin-top: 24px;\n  flex-direction: column;\n  row-gap: 24px;\n  padding: 12px;\n  background-color: white;\n  border-radius: 8px;\n  \n  .header {\n    color: $base-ui-color;\n    font: normal normal normal 14px/17px Dosis;\n    font-size: 22px;\n    font-weight: 500;\n  }\n  \n  .label {\n    color: #434343;\n    font: normal normal normal 14px/17px Dosis;\n    font-size: 20px;\n    font-weight: 500;\n  }\n  \n}\n\n.itemsContainer {\n  display: flex;\n  flex-direction: column;\n  row-gap: 12px;\n}\n\n.itemRow {\n  display: flex;\n  width: 40vw;\n  flex-direction: 'row';\n  column-gap: 8px;\n}\n\n.item {\n  flex: 1;\n  background-color: #EDEDED;\n  border-radius: 8px;\n  padding: 12px 12px;\n  text-align: center;\n  color: #434343;\n  \n  &.left {\n    min-width: 70%;\n    text-align: start;\n  }\n}\n\n.iconRound {\n  color: $base-ui-color\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
